module.exports = __webpack_public_path__ + "static/img/mainnews.a43c23b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/mainnews.jpg
// module id = YQ5I
// module chunks = 10